import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { FaArrowUp } from 'react-icons/fa';
const BackToTop = ({
  type,
  showAfterPixels
}) => {
  const [goToTop, setGoToTop] = useState(false);
  useEffect(() => {
    const handleOnScroll = () => setGoToTop(window.scrollY >= showAfterPixels);
    document.addEventListener('scroll', handleOnScroll);
    return () => document.removeEventListener('scroll', handleOnScroll);
  }, [showAfterPixels]);
  const handleBackToTop = event => {
    event.preventDefault();
    window.scroll({
      top: 0,
      left: 0,
      behavior: 'smooth'
    });
  };
  return goToTop && /*#__PURE__*/React.createElement("a", {
    href: "#top",
    className: type,
    onClick: handleBackToTop,
    "aria-label": "Back to top"
  }, /*#__PURE__*/React.createElement(FaArrowUp, null));
};
BackToTop.propTypes = {
  type: PropTypes.string,
  showAfterPixels: PropTypes.number
};
BackToTop.defaultProps = {
  type: 'backtotop',
  showAfterPixels: 200
};
export default BackToTop;
//# sourceMappingURL=BackToTop.js.map